import api from "../../api/index";
import Vue from "vue";

const registerroute = `${process.env.VUE_APP_BASE_URI}/auth/register`;
const enterpriselogin = `${process.env.VUE_APP_BASE_URI}/auth/login`;
const resetPassword = `${process.env.VUE_APP_BASE_URI}/auth/forgotpassword`;
const changePassword = `${process.env.VUE_APP_BASE_URI}/auth/resetpassword`;
const updateprofile = `${process.env.VUE_APP_BASE_URI}/auth/user/profile`;
const fetchprofile = `${process.env.VUE_APP_BASE_URI}/auth/profile`;
const updateTermsUrl = `${process.env.VUE_APP_BASE_URI}/auth/updateTerms`;
const verifymail = `${process.env.VUE_APP_BASE_URI}/auth/verify`;
const createpassword = `${process.env.VUE_APP_BASE_URI}/users/setup`;
const logoutUrl = `${process.env.VUE_APP_BASE_URI}/auth/logout`;
const rolePerm = `${process.env.VUE_APP_BASE_URI}/roles`;

const getDefaultState = () => {
  return {
    token: localStorage.getItem("token") || "",
    profile: {},
    loginCount: "",
    status: "",
    showTerms: false,
    timezone: "",
    roleModulePermissions: {},
    currentModulePermissions: {},
    modulePermimissions: {},
  };
};

const state = getDefaultState();

const getters = {
  isLoggedOn: (state) => (state.token ? true : false),
  authState: (state) => state.status,
  profile: (state) => state.profile,
  loginCount: (state) => state.loginCount,
  token: (state) => state.token,
  showTerms: (state) => state.showTerms,
  currentTimezone: (state) => state.timezone,
  userPermissions: (state) => {
    return state.roleModulePermissions;
  },
  canPerformAction: (state) => (moduleName, action) => {
    return state.roleModulePermissions[moduleName]?.[action] || false;
  },
  currentModulePermissions: (state) => state.currentModulePermissions,
  modulePermimissions: (state) => state.modulePermimissions,
};

const actions = {
  async register({ commit }, newUser) {
    commit("register_request");
    const res = await api.post(registerroute, newUser);
    // if (res.data.success) {
    //   const token = res.data.payload.token.accessToken;
    //   const profile = res.data.payload.user;
    //   localStorage.setItem("token", token);
    //   api.defaults.headers.common.Authorization = token;
    //   commit("register_success", { token, profile });
    // }
    return res;
  },

  async login({ commit }, user) {
    commit("login_request");
    const res = await api.post(enterpriselogin, user);
    if (res.data.success) {
      const token = res.data.payload.tokens.accessToken;
      const profile = res.data.payload.user;
      const showTerms = res.data.payload.isShowTermsAndConditions;
      const roleModulePermissions = res.data.payload.user.roleModulePermissions;
      localStorage.setItem("token", token);
      api.defaults.headers.common.Authorization = token;
      commit("login_success", {
        token,
        profile,
        showTerms,
        roleModulePermissions,
      });
    }
    return res;
  },

  async logout({ commit }) {
    // await api.get(logoutUrl);
    localStorage.removeItem("token");
    delete api.defaults.headers.common.Authorization;
    await commit("logout");
  },

  async resetPass({ commit }, user) {
    commit("reset_request");
    const res = await api.post(resetPassword, user);
    if (res.data.success) {
      commit("reset_success");
    }
    return res;
  },

  async loadReset({ commit }, { token }) {
    commit("loadreset_request");
    const res = await api.get(`${changePassword}/${token}`);
    if (res.data.success) {
      commit("loadreset_success");
    }
    return res;
  },

  async verifyMail({ commit }, { token }) {
    commit("verifymail_request");
    const res = await api.get(`${verifymail}/${token}`);
    if (res.data.success) {
      commit("verifymail_success");
    }
    return res;
  },

  async verifyUser({ commit }, { token }) {
    commit("verifyuser_request");
    const res = await api.get(`${createpassword}/${token}/verify`);
    if (res.data.success) {
      commit("verifyuser_success");
    }
    return res;
  },

  async createPassword({ commit }, { token, password }) {
    commit("createpassword_request");
    //console.log(password)
    const res = await api.post(`${createpassword}`, {
      token,
      ...password,
    });
    if (res.data.success) {
      commit("createpassword_success");
    }
    return res;
  },

  async changePass({ commit }, { token, user }) {
    commit("change_request");
    const res = await api.patch(`${changePassword}/${token}`, user);
    if (res.data.success) {
      commit("change_success");
    }
    return res;
  },

  async updateProfile({ commit }, updatedprofile) {
    commit("updateprofile_request");
    const res = await api.patch(updateprofile, updatedprofile);
    if (res.data.success) {
      commit("updateprofile_success", res.data.payload);
    }
    return res;
  },

  async fetchProfile({ commit }) {
    commit("fetchprofile_request");
    const res = await api.get(fetchprofile);
    if (res.data.success) {
      commit("fetchprofile_success", res.data.payload);
      //console.log(res.data);
    }
    return res;
  },

  async updateTerms({ commit }) {
    commit("updateTerms_request");
    const res = await api.patch(updateTermsUrl, { termsAndConditions: true });
    if (res.data.success) {
      commit("updateTerms_success");
    }
    return res;
  },

  async updateLogin({ commit }, count) {
    commit("updatelogincount", count);
  },

  async setTimezone({ commit }, timezone) {
    await commit("settimezone_success", timezone);
  },

  async resetAuthState({ commit }) {
    await commit("resetauthstate_success");
  },

  canPerformAction({ state }, { moduleName, action }) {
    return state.roleModulePermissions[moduleName]?.[action] || false;
  },

  async updateRolePerm({ commit }, { role, modulePermissions }) {
    const res = await api.patch(`${rolePerm}/${role}`, modulePermissions);
    if (res.data.success) {
      Vue.toasted.success('Permissions updated', {
        position: "top-right",
        duration: 5000,
      });
    }
    return res;
  },

  async getRolePerm({ commit }, role) {
    const res = await api.get(`${rolePerm}/${role}`);
    if (res.data.success) {
      commit("get_role_perm_success", res.data.payload.modulePermissions);
    }
    return res;
  },
  getRoles({ commit }) {
    const res = api.get(`${rolePerm}`);
    if (res.data.success) {
      commit("get_current_role_success", res.data.payload);
    }
    return res;
  },
};

const mutations = {
  register_request: (state) => (state.status = "loading"),
  register_success: (state, { token, profile }) => {
    state.status = "success";
    state.token = token;
    state.profile = profile;
  },
  login_request: (state) => (state.status = "loading"),
  login_success: (
    state,
    { token, profile, showTerms, roleModulePermissions }
  ) => {
    state.status = "success";
    state.token = token;
    state.profile = profile;
    state.showTerms = showTerms;
    state.roleModulePermissions = roleModulePermissions;
  },
  logout: (state) => Object.assign(state, getDefaultState()),
  reset_request: (state) => (state.status = "loading"),
  reset_success: (state) => (state.status = "success"),
  change_request: (state) => (state.status = "loading"),
  change_success: (state) => (state.status = "success"),
  loadreset_request: (state) => (state.status = "loading"),
  loadreset_success: (state) => (state.status = "success"),
  verifymail_request: (state) => (state.status = "loading"),
  verifymail_success: (state) => (state.status = "success"),
  verifyuser_request: (state) => (state.status = "loading"),
  verifyuser_success: (state) => (state.status = "success"),
  createpassword_request: (state) => (state.status = "loading"),
  createpassword_success: (state) => (state.status = "success"),
  updateprofile_request: (state) => (state.status = "loading"),
  updateprofile_success: (state, profile) => {
    (state.status = "success"), (state.profile = profile);
  },
  fetchprofile_request: (state) => (state.status = "loading"),
  fetchprofile_success: (state, profile) => {
    (state.status = "success"), (state.profile = profile);
  },
  updateTerms_request: (state) => (state.status = "loading"),
  updateTerms_success: (state) => {
    state.showTerms = false;
  },
  get_role_perm_success: (state, roleModulePermissions) => {
    state.currentModulePermissions = roleModulePermissions;
  },
  get_current_role_success: (state, roleModulePermissions) => {
    state.modulePermimissions = roleModulePermissions;
  },
  updatelogincount: (state, count) => (state.loginCount = count),
  settimezone_success: (state, timezone) => {
    state.timezone = timezone;
  },
  resetauthstate_success: (state) => Object.assign(state, getDefaultState()),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
